import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import cx from "classnames";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from '../Button';
import { getTheme } from '../ThemeProvider/index';

var ModalLocale = {
  okText: "OK",
  cancelText: "Cancel"
};

var CommonModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CommonModal, _React$Component);

  var _super = _createSuper(CommonModal);

  function CommonModal() {
    var _this;

    _classCallCheck(this, CommonModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOk", function (e) {
      var onOk = _this.props.onOk;

      if (onOk) {
        onOk(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function (e) {
      var onCancel = _this.props.onCancel;

      if (onCancel) {
        onCancel(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderModalBody", function () {
      return /*#__PURE__*/React.createElement(ModalBody, null, _this.props.children);
    });

    _defineProperty(_assertThisInitialized(_this), "renderModalFooter", function () {
      var okText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ModalLocale.okText;
      var cancelText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ModalLocale.cancelText;
      var okButtonProps = arguments.length > 2 ? arguments[2] : undefined;
      var cancelButtonProps = arguments.length > 3 ? arguments[3] : undefined;
      var defaultFooter = /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, _extends({
        btype: "basic",
        onClick: _this.handleCancel
      }, cancelButtonProps), cancelText), /*#__PURE__*/React.createElement(Button, _extends({
        onClick: _this.handleOk
      }, okButtonProps), okText));
      var footer = _this.props.footer === undefined ? defaultFooter : /*#__PURE__*/React.createElement(ModalFooter, null, _this.props.footer);
      return footer;
    });

    return _this;
  }

  _createClass(CommonModal, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          title = _this$props.title,
          modalTitle = _this$props.modalTitle,
          backdrop = _this$props.backdrop,
          footer = _this$props.footer,
          toggle = _this$props.toggle,
          onCancel = _this$props.onCancel,
          _onClosed = _this$props.onClosed,
          onClose = _this$props.onClose,
          onOk = _this$props.onOk,
          className = _this$props.className,
          contentClassName = _this$props.contentClassName,
          wrapClassName = _this$props.wrapClassName,
          okText = _this$props.okText,
          cancelText = _this$props.cancelText,
          okButtonProps = _this$props.okButtonProps,
          cancelButtonProps = _this$props.cancelButtonProps,
          restProps = _objectWithoutProperties(_this$props, ["prefixCls", "title", "modalTitle", "backdrop", "footer", "toggle", "onCancel", "onClosed", "onClose", "onOk", "className", "contentClassName", "wrapClassName", "okText", "cancelText", "okButtonProps", "cancelButtonProps"]);

      var theme = getTheme().theme;
      return /*#__PURE__*/React.createElement(Modal, _extends({
        backdrop: backdrop,
        wrapClassName: cx(wrapClassName, {
          noBackdrop: backdrop === false
        }),
        className: cx('sfx-react-ui-theme', className),
        "data-theme": theme,
        onClosed: function onClosed() {
          _onClosed && _onClosed();
          onClose && onClose();
        },
        contentClassName: cx("".concat(prefixCls, "modal-wrap"), contentClassName)
      }, restProps), /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: toggle
      }, modalTitle || title), this.renderModalBody(), footer !== null && this.renderModalFooter(okText, cancelText, okButtonProps, cancelButtonProps));
    }
  }]);

  return CommonModal;
}(React.Component);

_defineProperty(CommonModal, "defaultProps", {
  centered: false,
  prefixCls: 'react-ui-'
});

_defineProperty(CommonModal, "info", void 0);

_defineProperty(CommonModal, "success", void 0);

_defineProperty(CommonModal, "error", void 0);

_defineProperty(CommonModal, "warn", void 0);

_defineProperty(CommonModal, "warning", void 0);

_defineProperty(CommonModal, "confirm", void 0);

export default CommonModal;